export const importLocalStorageData = (storeUserData, setUserAccount, selectShopDepartment) => {
  let lsUser = localStorage.getItem('user');

  let lsUserData = localStorage.getItem('userData');

  // localStorage cleared if there is misalignment in structure
  // Response from new user routes now reflect accounts property as accountDepartments
  if ((lsUser && lsUser.accounts) || (lsUserData && lsUserData.accounts)) {
    localStorage.clear();
    lsUser = null;
    lsUserData = null;
  }

  const lsSelectedDepartment = localStorage.getItem('selectedDepartment');

  if (lsUserData) {
    const currAccount = JSON.parse(lsUserData);
    setUserAccount(currAccount);
  }

  if (lsUser) {
    const parsedUser = JSON.parse(lsUser);

    // localStorage cleared if parsed userData structure contains numbers instead of strings
    if (parsedUser.accountDepartments?.some(acct => typeof acct.accountId !== 'string')) {
      localStorage.clear();
      lsUser = null;
      lsUserData = null;

      return;
    }

    storeUserData(parsedUser);

    if (parsedUser.accountDepartments && parsedUser.accountDepartments.length === 1) {
      const { accountId: number, accountName: name, id } = parsedUser.accountDepartments[0];
      const newAccount = { id, number, name };
      setUserAccount(newAccount);
      localStorage.setItem('userData', JSON.stringify(newAccount));
    }
  }

  if (lsSelectedDepartment) selectShopDepartment(JSON.parse(lsSelectedDepartment));
};
